import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Route } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css';
import Logo from './components/login/logo';
import Cover from './components/login/cover';
import dh from './helpers/defaultImages.helper';

// Import Main styles for this application
import './scss/style.css';
import './App.css';

// Containers

import 'sweetalert/dist/sweetalert.css';
import Main from './containers/main';
import DownloadCovers from './components/login/downloadCovers';
import CustomColors from './components/customColors';
// import ConfirmInvite from './views/confirmInvite';

const App = () => (
  <React.Fragment>
    <CustomColors />
    <div style={{ position: 'absolute', right: '4000px' }}>
      <Logo />
      <Cover/>
      <DownloadCovers/>
      <img src={dh.defaultLogin} />
      <img src={dh.defaultLogoSite} />
      <img src={dh.defaultCoverImgSettings} />
      <img src={dh.loginCoverImgSettings} />
      <img src={dh.defaultUserLogo} />
    </div>
    <ToastContainer />
    <Route path="/" component={Main} />
  </React.Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js